<div class="chartHorizontalBar" *ngIf="config">
  <p-chart #graphBar type="bar" *ngIf="height && data && config && plugins"
    responsive="true"
    [ngStyle]="{'height': chartHeight, 'display': 'block'}"
    [data]="data" 
    [options]="config" 
    [plugins]="plugins"
    class="barChart"
  ></p-chart>
</div>
